/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Nexata_Reingest_SuccessInputs */

const es_tools_nexata_reingest_success = /** @type {(inputs: Tools_Nexata_Reingest_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivos reindexados`)
};

const en_tools_nexata_reingest_success = /** @type {(inputs: Tools_Nexata_Reingest_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Files reindexed`)
};

/**
* | output |
* | --- |
* | "Files reindexed" |
*
* @param {Tools_Nexata_Reingest_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_nexata_reingest_success = /** @type {((inputs?: Tools_Nexata_Reingest_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Nexata_Reingest_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_nexata_reingest_success(inputs)
	return en_tools_nexata_reingest_success(inputs)
});
export { tools_nexata_reingest_success as "tools.nexata.reingest_success" }